import { t } from '../i18n.es.js';
import React from 'react';
import { styled, Currency } from '@teko/ui';
import Link from 'next/link';
import { Tag } from '@teko/ds-foundation';
import { TableDivider } from '../OrderDetail/TableDivider/TableDivider.es.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const Table = styled.table`
  background-color: #fff;
  border-radius: 8px;
  width: 100%;
  border-spacing: 0;

  thead {
    text-align: left;
    th {
      border-bottom: 1px solid #e0e0e0;
      padding: 16px;
      font-size: 16px;
      font-weight: 700;
      color: #333;
    }
  }

  tbody {
    td {
      font-size: 14px;
      padding: 16px;
      width: max-content;
      vertical-align: top;
    }

    tr {
      &:first-of-type {
        margin-left: 16px;
      }
      &:last-child {
        margin-right: 16px;
      }
    }
  }
`;
const OrderID = styled.a`
  cursor: pointer;
  text-decoration: none;

  &:link,
  &:visited {
    color: #047fff;
  }

  &:hover {
    color: #0058b5;
  }
`;
const TableData = styled.td(({ direction }) => `
  text-align: ${direction}
`);
const TableHead = styled.th(({ direction, width }) => `
  text-align: ${direction};
  width: ${width ? `${width}%` : "initial"};
`);
const ProductName = styled.th`
  width: 36%;
  max-width: 40%;
`;
const Name = styled.div(({ lineclamp }) => `
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: ${lineclamp};
  -webkit-box-orient: vertical;
`);
const OrderList = ({
  orders,
  lineclamp = 1,
  linkExtractor,
  showOriginalCode
}) => {
  if (!orders.length)
    return null;
  return /* @__PURE__ */ React.createElement("div", {
    style: { minHeight: 550 }
  }, /* @__PURE__ */ React.createElement(Table, null, /* @__PURE__ */ React.createElement("thead", null, /* @__PURE__ */ React.createElement("tr", null, /* @__PURE__ */ React.createElement("th", null, t("M\xE3 \u0111\u01A1n h\xE0ng")), /* @__PURE__ */ React.createElement("th", null, t("Ng\xE0y mua")), /* @__PURE__ */ React.createElement(ProductName, null, t("S\u1EA3n ph\u1EA9m")), /* @__PURE__ */ React.createElement(TableHead, {
    direction: "right"
  }, t("T\u1ED5ng ti\u1EC1n (\u0111)")), /* @__PURE__ */ React.createElement(TableHead, {
    direction: "right",
    width: 16
  }, t("Tr\u1EA1ng th\xE1i")))), /* @__PURE__ */ React.createElement("tbody", null, orders.map((order, index) => {
    var _a;
    const showLink = !!(linkExtractor && ((_a = linkExtractor(order)) == null ? void 0 : _a.href));
    const clearanceTypeTag = order.productClearanceTypeTag;
    return /* @__PURE__ */ React.createElement(React.Fragment, {
      key: index
    }, /* @__PURE__ */ React.createElement("tr", null, /* @__PURE__ */ React.createElement("td", null, showLink ? /* @__PURE__ */ React.createElement(Link, __spreadProps(__spreadValues({}, linkExtractor(order)), {
      legacyBehavior: true
    }), /* @__PURE__ */ React.createElement(OrderID, null, showOriginalCode && order.originalCode || order.code)) : showOriginalCode && order.originalCode || order.code), /* @__PURE__ */ React.createElement("td", null, order.date), /* @__PURE__ */ React.createElement("td", null, /* @__PURE__ */ React.createElement(Name, {
      lineclamp
    }, clearanceTypeTag && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Tag, {
      type: "secondary",
      variant: "branding",
      content: clearanceTypeTag
    }), "\xA0"), order.name)), /* @__PURE__ */ React.createElement(TableData, {
      direction: "right"
    }, /* @__PURE__ */ React.createElement(Currency, {
      value: order.price,
      hideCurrency: true
    })), /* @__PURE__ */ React.createElement(TableData, {
      direction: "right"
    }, order.renderStatus)), index !== orders.length - 1 ? /* @__PURE__ */ React.createElement(TableDivider, {
      colCount: 5,
      mr: 16,
      ml: 16
    }) : null);
  }))));
};

export { OrderList };
